<template>
  <div class="incentive-level-progress flex min-w-[8rem] flex-col gap-1">
    <span class="text-sm font-medium text-gray-900">{{ level }}</span>
    <div
      class="incentive-level-progress__bar h-1.5 w-full overflow-hidden rounded-full bg-gray-200"
    >
      <span
        class="incentive-level-progress__fill block h-full rounded-full bg-blue-500 transition-all"
        :style="{ width: `${normalizedPercent}%` }"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "IncentiveLevelProgressCell",

  props: {
    level: {
      type: Number,
      default: 1,
    },

    progressPercent: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    normalizedPercent() {
      const value = Number(this.progressPercent);

      if (Number.isNaN(value)) {
        return 0;
      }

      return Math.min(100, Math.max(0, value));
    },
  },
};
</script>
